import React, { useState } from 'react';
import { ChevronDownIcon, ChevronUpIcon } from 'lucide-react';
const faqs = [{
  question: 'Are online degrees respected by employers?',
  answer: 'Yes. Employers increasingly view online degrees from accredited institutions exactly the same as traditional on-campus degrees. What matters most to employers is the accreditation of the school and the skills you acquire, not the medium of instruction.'
}, {
  question: 'How do I know if a school is accredited?',
  answer: "We only partner with schools that hold regional or national accreditation recognized by the U.S. Department of Education. You can verify a school's accreditation status on their website or through the Database of Accredited Postsecondary Institutions and Programs."
}, {
  question: 'Can I get financial aid for an online degree?',
  answer: 'Yes. Students enrolled in accredited online degree programs are generally eligible for the same federal financial aid (grants and loans) as on-campus students. You will need to complete the Free Application for Federal Student Aid (FAFSA) to determine your eligibility.'
}, {
  question: 'How much does this matching service cost?',
  answer: 'Our matching service costs you nothing. We are compensated by our partner schools when we connect them with prospective students, which is what allows us to provide this resource at no cost to you.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const toggleFaq = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section className="py-16 bg-warm border-t border-gray-200" data-id="element-291" data-mp="2oeghzcuodo62">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-292" data-mp="2odneqluxdgso">
        <div className="text-center mb-10" data-id="element-293" data-mp="2jgexcnhlpgsh">
          <h2 className="text-3xl font-bold text-navy mb-4" style={{
          color: "#6659B0"
        }} data-id="element-294" data-mp="2jd954zdodysj">
            Frequently Asked Questions
          </h2>
          <p className="text-gray-600" data-id="element-295" data-mp="p248if10ammp">
            Common questions about online education and our service.
          </p>
        </div>

        <div className="space-y-4" data-id="element-296" data-mp="2p5euc9cs7fof">
          {faqs.map((faq, index) => <div key={index} className="bg-white border border-gray-200 rounded-lg overflow-hidden shadow-sm transition-all duration-200" data-id="element-297" data-mp="2u1vj95rt1y2k" data-mpi={index}>
              <button className="w-full px-6 py-4 text-left flex justify-between items-center focus:outline-none focus:ring-2 focus:ring-inset focus:ring-navy" onClick={() => toggleFaq(index)} aria-expanded={openIndex === index} data-id="element-298" data-mp="2z0gk97evsls2">
                <span className="font-semibold text-navy" data-id="element-299" data-mp="3d1j6pl9sfy3i">{faq.question}</span>
                {openIndex === index ? <ChevronUpIcon className="w-5 h-5 text-gray-500 flex-shrink-0" data-id="element-300" data-mp="3hshq4tq2pcaz" /> : <ChevronDownIcon className="w-5 h-5 text-gray-500 flex-shrink-0" data-id="element-301" data-mp="3ht1644w5xqmd" />}
              </button>

              {openIndex === index && <div className="px-6 pb-4 pt-0" data-id="element-302" data-mp="3qt7itok1emkh">
                  <p className="text-gray-600 text-sm leading-relaxed" data-id="element-303" data-mp="3quimlodhfubl">
                    {faq.answer}
                  </p>
                </div>}
            </div>)}
        </div>
      </div>
    </section>;
}